export default "__VITE_ASSET__VTqEirsn__"